import { render } from "./UserArea.vue?vue&type=template&id=82256f68&scoped=true"
import script from "./UserArea.vue?vue&type=script&lang=js"
export * from "./UserArea.vue?vue&type=script&lang=js"

import "./UserArea.vue?vue&type=style&index=0&id=82256f68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82256f68"]])

export default __exports__